import { render, staticRenderFns } from "./trans_health.vue?vue&type=template&id=633bc475&scoped=true"
import script from "./trans_health.vue?vue&type=script&lang=js"
export * from "./trans_health.vue?vue&type=script&lang=js"
import style0 from "./trans_health.vue?vue&type=style&index=0&id=633bc475&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633bc475",
  null
  
)

export default component.exports